const projects = [
  {
    id: 1,
    title: "Fast Xcess",
    category: "Business Website",
    image: "/images/projects/fastxcess.jpg",
    url: "https://moobeenquader.com/",
    description:
      "Modern responsive business website focused on performance, user experience, and lead generation.",
    technologies: [
      "WordPress",
      "Elementor",
      "PHP",
      "JavaScript",
      "CSS3",
    ],
  },
  {
    id: 2,
    title: "Sabba",
    category: "Corporate Website",
    image: "/images/projects/sabba.jpg",
    url: "https://moobeenquader.com/",
    description:
      "Professional corporate website with responsive layouts and optimized performance.",
    technologies: [
      "WordPress",
      "Elementor",
      "Bootstrap",
      "JavaScript",
    ],
  },
  {
    id: 3,
    title: "Anna",
    category: "Portfolio Website",
    image: "/images/projects/anna.jpg",
    url: "https://moobeenquader.com/",
    description:
      "Elegant portfolio website featuring modern UI, animations, and responsive design.",
    technologies: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "WordPress",
    ],
  },
  {
    id: 4,
    title: "Travel Agency",
    category: "Travel Website",
    image: "/images/projects/travel.jpg",
    url: "https://moobeenquader.com/",
    description:
      "Travel booking website with engaging layouts and optimized user experience.",
    technologies: [
      "WordPress",
      "WooCommerce",
      "PHP",
      "JavaScript",
    ],
  },
  {
    id: 5,
    title: "Mark",
    category: "Business Website",
    image: "/images/projects/mark.jpg",
    url: "https://moobeenquader.com/",
    description:
      "Business-focused website with clean UI and responsive layouts for all devices.",
    technologies: [
      "WordPress",
      "CSS3",
      "JavaScript",
      "Bootstrap",
    ],
  },
  {
    id: 6,
    title: "Doctor",
    category: "Healthcare Website",
    image: "/images/projects/doctor.jpg",
    url: "https://moobeenquader.com/",
    description:
      "Healthcare website designed for clinics and medical professionals with appointment features.",
    technologies: [
      "WordPress",
      "Elementor",
      "PHP",
      "CSS3",
    ],
  },
  {
    id: 7,
    title: "SemperFi",
    category: "Corporate Website",
    image: "/images/projects/semperfi.jpg",
    url: "https://moobeenquader.com/",
    description:
      "Corporate website emphasizing modern branding, performance, and responsive design.",
    technologies: [
      "WordPress",
      "JavaScript",
      "Bootstrap",
      "CSS3",
    ],
  },
  {
    id: 8,
    title: "Square Windows",
    category: "Construction Website",
    image: "/images/projects/squarewindows.jpg",
    url: "https://moobeenquader.com/",
    description:
      "Construction company website with service showcases, project galleries, and lead generation.",
    technologies: [
      "WordPress",
      "WooCommerce",
      "Elementor",
      "JavaScript",
    ],
  },
];

export default projects;